import ReadyToStart from './ReadyToStart';

export default ReadyToStart;
